// asyncronous, gaan we gebruiken om naar de api te gaan
import {
  api,
} from '@/utils';

import Vue from 'vue';

import APPOINTMENT_ACTION_TYPES from './appointment.action-types';
import APPOINTMENT_MUTATION_TYPES from './appointment.mutation-types';

const APPOINTMENT_ACTIONS = {
  [APPOINTMENT_ACTION_TYPES.FETCH_DATA_CUSTOMER]({
    commit,
  }, fetchDataCustomerObject) {
    return new Promise((resolve, reject) => {
      commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, true);
      api.get(`customer/getcustomerdata?licensePlate=${fetchDataCustomerObject.licensePlate.toLowerCase()}&company=${fetchDataCustomerObject.company.toLowerCase()}`)
        .then((response) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_INITIALSTATE, false);

          if (response.data != null) {
            commit(APPOINTMENT_MUTATION_TYPES.APPEND_CUSTOMER, response.data);
          }

          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
          resolve();
        })
        .catch((error) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.FETCH_DATA_CUSTOMER_MOBILE]({
    commit,
  }, fetchDataCustomerObject) {
    return new Promise((resolve, reject) => {
      commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, true);
      api.get(`customer/getcustomerdatamobile?licensePlate=${fetchDataCustomerObject.licensePlate.toLowerCase()}&company=${fetchDataCustomerObject.company.toLowerCase()}`)
        .then((response) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_INITIALSTATE, false);
          if (response.data != null) {
            commit(APPOINTMENT_MUTATION_TYPES.APPEND_CUSTOMER, response.data);
            commit(APPOINTMENT_MUTATION_TYPES.SET_SERVICETYPE, 'change');
            commit(APPOINTMENT_MUTATION_TYPES.SET_COMPANY, fetchDataCustomerObject.company);
            commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);

            if (response.data.driver != null && response.data.driver.chassis != null) {
              commit(APPOINTMENT_MUTATION_TYPES.SET_CHASSIE, response.data.driver.chassis);
            }
            commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
            resolve();
          }

          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
          reject();
        })
        .catch((error) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.FETCH_DATA_CUSTOMER_TPP]({
    commit,
  }, rid) {
    return new Promise((resolve, reject) => {
      commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, true);
      api.get(`customer/getcustomerdatatpp?pGuid=${rid}`)
        .then((response) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_INITIALSTATE, false);
          if (response.data != null) {
            commit(APPOINTMENT_MUTATION_TYPES.SET_TIRETYPE, { tireType: 'ms', changeTireType: true });
            commit(APPOINTMENT_MUTATION_TYPES.SET_SERVICETYPE, 'change');
            commit(APPOINTMENT_MUTATION_TYPES.APPEND_CUSTOMER, response.data);
            commit(APPOINTMENT_MUTATION_TYPES.SET_RID, rid);

            switch (response.data.driver.language) {
              case 'nl':
                commit(APPOINTMENT_MUTATION_TYPES.SET_LANGUAGE, 'nl');
                Vue.config.language = 'nl_BE';
                break;
              case 'fr':
                commit(APPOINTMENT_MUTATION_TYPES.SET_LANGUAGE, 'fr');
                Vue.config.language = 'fr_BE';
                break;
              default:
                commit(APPOINTMENT_MUTATION_TYPES.SET_LANGUAGE, 'fr');
                Vue.config.language = 'nl_BE';
                break;
            }
            commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
            resolve();
          }

          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
          reject();
        })
        .catch((error) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.FETCH_DATA_CUSTOMER_REGION]({
    commit,
  }, getRegionObject) {
    return new Promise((resolve, reject) => {
      commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, true);
      api.get(`address/getregionmobile?postalCode=${getRegionObject.postalCode}`)
        .then((response) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_INITIALSTATE, false);
          if (response.data != null) {
            commit(APPOINTMENT_MUTATION_TYPES.SET_SERVICETYPE, 'change');
            commit(APPOINTMENT_MUTATION_TYPES.SET_REGIONCODE, response.data.region);
          }
          api.get(`customer/getcustomerdatamobile?licensePlate=${getRegionObject.licensePlate.toLowerCase()}&company=${response.data.region}`)
            .then((responseMobile) => {
              commit(APPOINTMENT_MUTATION_TYPES.SET_INITIALSTATE, false);
              if (responseMobile.data != null) {
                commit(APPOINTMENT_MUTATION_TYPES.APPEND_CUSTOMER, responseMobile.data);
                // console.log(responseMobile.data);

                if (responseMobile.data.addresses.length > 0) {
                  commit(APPOINTMENT_MUTATION_TYPES.SET_ADDRESS, responseMobile.data.addresses[0].id);
                }
                if (responseMobile.data.driver != null && responseMobile.data.driver.chassis != null) {
                  commit(APPOINTMENT_MUTATION_TYPES.SET_CHASSIE, responseMobile.data.driver.chassis);
                }

                commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
                resolve();
              }

              commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
              reject();
            })
            .catch((error) => {
              commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
              commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
              reject(error);
            });
        })
        .catch((error) => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.SET_SLOTNUMBER]({
    commit,
  }, reservationRequestModel) {
    return new Promise((resolve, reject) => {
      commit(APPOINTMENT_MUTATION_TYPES.CLEAR_ERROR_SLOT, false);

      // Huidige reservering wegdoen indien er al een slotnumber is
      if (reservationRequestModel.slotNumber !== '') {
        api.post(
          'appointment/deletereservation', {
          slotNumber: reservationRequestModel.slotNumber,
        },
        );
      }

      api.post('/appointment/requestreservation', reservationRequestModel)
        .then(response => {
          // // When request reservation failed
          if (response.data === '') {
            commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR_SLOT, true);
            resolve();
          }

          const reservation = {
            slotNumber: response.data,
            date: reservationRequestModel.date,
            hour: reservationRequestModel.hour,
            duration: reservationRequestModel.duration,
          };

          commit(APPOINTMENT_MUTATION_TYPES.APPEND_RESERVATION, reservation);
          resolve();
        })
        .catch(error => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.CLEAR_SLOTNUMBER]({
    commit,
  }, slotNumber) {
    return new Promise((resolve) => {
      commit(APPOINTMENT_MUTATION_TYPES.CLEAR_RESERVATION);

      // Huidige reservering wegdoen indien er al een slotnumber is
      if (slotNumber !== '') {
        api.post(
          'appointment/deletereservation', {
          slotNumber: slotNumber,
        },
        );
      }

      resolve();
    });
  },
  [APPOINTMENT_ACTION_TYPES.SET_APPOINTMENT]({
    commit,
  }, appointmentPostObject) {
    commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, true);
    return new Promise((resolve, reject) => {
      api.post('/appointment/requestappointmentall', appointmentPostObject)
        .then(() => {
          resolve();
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
        })
        .catch(error => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.SET_APPOINTMENT_MOBILE_BUS]({ commit }, appointmentPostObjectComp) {
    return new Promise((resolve, reject) => {
      commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, true);
      api.post('/appointment/requestappointmentall', appointmentPostObjectComp)
        .then(() => {
          resolve();
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
        })
        .catch(error => {
          // NEED TO CHECK IF ALREADY CLAIMED

          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.SET_APPOINTMENT_MOBILE_TPP]({ commit }, appointmentPostObjectComp) {
    return new Promise((resolve, reject) => {
      // console.log(appointmentPostObjectComp);

      api.post('/appointment/requestappointmentall', appointmentPostObjectComp)
        .then(() => {
          resolve();
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
        })
        .catch(error => {
          // NEED TO CHECK IF ALREADY CLAIMED

          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
  [APPOINTMENT_ACTION_TYPES.UPDATE_APPOINTMENT]({
    commit,
  }, appointmentUpdateObject) {
    commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, true);
    return new Promise((resolve, reject) => {
      api.post(`/appointment/updateappointment?deliveryNote=${appointmentUpdateObject.deliveryNote}`, appointmentUpdateObject.reservation)
        .then(() => {
          resolve();
          commit(APPOINTMENT_MUTATION_TYPES.SET_LOADING_STATE, false);
        })
        .catch(error => {
          commit(APPOINTMENT_MUTATION_TYPES.SET_ERROR, error);
          reject(error);
        });
    });
  },
};

export default APPOINTMENT_ACTIONS;
